import React, { createContext, useState, useContext } from "react";

const ClikkleContext = createContext();

export const ClikkleProvider = ({ children }) => {
    const [ClikkleItems, setClikkleItems] = useState([]);

    return (
        <ClikkleContext.Provider value={{ ClikkleItems, setClikkleItems }}>
            {children}
        </ClikkleContext.Provider>
    );
};

export const useClikkle = () => useContext(ClikkleContext);
